// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_21wfIBLoY2Myli2_9aL9Nq","imagePullRight":"_23y7ukBrSS2naLH8HQ3KaN"};